import * as React from 'react';
import NavMenu from './NavMenu';

export default (props: { children?: React.ReactNode }) => (
    <React.Fragment>
        <NavMenu/>        
        {props.children}
        <div className="page-footer" style={{ height: '100px' }}>

        </div>
    </React.Fragment>
);
